<template>
    <div>
        <breadcrumb :routerList="[{to:'/dingd/material/inland',title:'订单管理'},{title:'内销订单'}]"/>
        <div class="h-piece">
            <div class="h-pieceIn2 n-xiao">
                <div class="h-pieceTitle2 " style="margin-left:10px">
                    <h1>项目名称</h1>
                </div>
                <div class="h-pieceCon2">
                    <div class="h-formLine">
                        <el-form :model="q" label-position="right" :inline="true"
                                 class="demo-ruleForm h-formbLine">
                            <el-form-item label="项目名称" class="h-elformWrap-2" required="true">
                                <el-select v-model="q.id" @change="queryXiangmu()"
                                           placeholder="请选择" clearable>
                                    <el-option v-for="item in allProjectByUser"
                                               :key="item.id"
                                               :label="item.projectName"
                                               :value="item.id">
                                        {{ item.projectName }}
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="售达方" class="h-elformWrap-2" prop="name" required="true">
                                <el-input v-model="this._user.username" placeholder="自带出"></el-input>
                            </el-form-item>
                            <el-form-item label="主合同编号" class="h-elformWrap-2" required="true">
                                <el-input v-model="q.orderMainContract" placeholder="自带出"></el-input>
                            </el-form-item>
                            <el-form-item label="分合同编号" class="h-elformWrap-2" required="true">
                                <el-input v-model="q.orderSubContract" placeholder="请先选择项目"></el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </div>
        </div>
        <div class="h-piece">
            <div class="h-pieceIn2">
                <div class="h-pieceTitle2" style="margin-left:10px">
                    <h1>订单信息</h1>
                </div>
                <div class="h-pieceCon2">
                    <div class="h-formLine n-two">
                        <el-form :model="formInline" label-position="right" :inline="true"
                                 class="demo-ruleForm h-formbLine">
                            <el-form-item label="销售区域" class="h-elformWrap-2" required="true">
                                <el-select v-model="formInline.orderCategory" >
                                    <el-option label="内销订单" value="1"></el-option>
                                    <el-option label="外销订单" value="2"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="销售组织编码" class="h-elformWrap-2" required="true">
                                <el-select v-model="formInline.saleGroupCode" style="width:3rem;">
                                    <el-option label="青岛海尔生物医疗-香港销售组织" value="6200"></el-option>
                                    <el-option label="青岛海尔生物医疗科技-销售组织" value="9370"></el-option>
                                    <el-option label="青岛海尔生物医疗-青岛销售组织" value="9390"></el-option>
                                    <el-option label="青岛海尔生物医疗-上海销售组织" value="9391"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="分销渠道" class="h-elformWrap-2" required="true">
                                <el-cascader
                                        style="width:2.8rem;"
                                        :options="options"
                                        v-model="selectedOptions"
                                        @change="handleChange">
                                </el-cascader>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </div>
        </div>
        <div class="h-table h-mrt30    bbbb" v-if="clickActive==1">
            <div class="h-pieceTitle2 message">
                <h1 class="h1">项目产品信息</h1>
            </div>
            <el-table
                    ref="multipleTable"
                    @selection-change="handleSelectionChange"
                    :data="tableData2"
                    stripe
					border
                    style="width: 100%">
                <el-table-column
                    type="selection"
                    width="70"
                    label="全选"
                    @change="getAllTotalPrice(multipleSelection)">
                </el-table-column>
                <el-table-column
                    fixed
                    type="index"
                    label="序号"
                    width="50">
                </el-table-column>
                <el-table-column
                    prop="materialCode"
                    label="产品编码"
                    width="100%">
                    <template slot-scope="scope" v-show="showHidden">
                        <el-input v-model="scope.row.materialCode" @change="getSingleOrder(scope.row)" placeholder="请输入"
                            class="h-tableInput" :disabled="showHidden2">
                        </el-input>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="proModelCode"
                    label="产品型号"
                    width="100%">
                </el-table-column>
                <el-table-column
                    prop="proNumber"
                    label="订单数量"
                    width="90"
                    :rules="[
                                { required: true, message: '请输入排序名称'},
                                { type: 'number', message: '必须为数字值',trigger: 'change'}
                            ]">
                    <template slot-scope="scope">
                        <el-input v-model.number="scope.row.proNumber" @change="getTotalPrice(scope.row)"
                            placeholder="请输入"
                            class="h-tableInput" auto-complete="off"></el-input>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="proBenchmarkPrice"
                    label="基准价"
                    width="80">
                </el-table-column>
                <el-table-column
                    prop="specialPrice"
                    label="特价"
                    width="70">
                </el-table-column>
                <el-table-column
                    prop="isStockUp"
                    label="是否备货"
                    width="110">
                    <template scope="scope">
                        <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder">
                            <el-form-item label="" style="heigth:30px;">
                                <el-select v-model="scope.row.isStockUp" class="h-tableInput">
                                    <el-option label="是" value="1"></el-option>
                                    <el-option label="否" value="0"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-form>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="spare3"
                        label="定制需求"
                        width="120">
                    <template scope="scope">
                        <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder">
                            <el-form-item label="">
                                <el-select v-model="scope.row.spare3" 
                                    :disabled="scope.row.cflag" class="h-tableInput">
                                    <el-option label="外壳镀金" value="1"></el-option>
                                    <el-option label="功率提升" value="2"></el-option>
                                    <el-option label="不定制" value="0"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-form>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="extraPrice"
                    label="定制加价"
                    width="80">
                </el-table-column>
                <el-table-column
                    prop="finalPrice"
                    label="成交价"
                    width="80">
                </el-table-column>
                <el-table-column
                    prop="totalPrice"
                    label="总价"
                    width="100%">
                </el-table-column>
                <el-table-column
                    prop="spare1"
                    label="客户渠道"
                    width="120">
                    <template slot-scope="scope">
                        <brselect class="h-tableInput" clearable category="qu_dao" :v="scope.row.spare1" v-model="scope.row.spare1"></brselect>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="contactName"
                    label="收货联系人"
                    width="100%">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.contactName" placeholder="请输入"
                            class="h-tableInput"></el-input>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="toAddress"
                    label="收货地址"
                    width="200">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.toAddress" placeholder="请输入"
                            class="h-tableInput"></el-input>
                    </template>
                </el-table-column>
                <el-table-column
                        label="预计收货日期"
                        class="h-elformWrap-2"
                        prop="receivedTime"
                        width="250">
                    <template slot-scope="scope">
                        <div class="block">
                            <el-date-picker
                                v-model="scope.row.receivedTime"
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="--选择--"
                                :picker-options="pickerOptions"
                                class="h-tableInput">
                            </el-date-picker>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="h-tableAdd" v-if="showHidden" @click="newZen">
                <a>新增一行</a>
            </div>
            <div class="jieguo">
                <span class="bizhong">币种</span>
                <span class="renminbi">{{ currency }}</span>
                <span class="dingdan">订单总价</span>
                <span class="yuan">{{ allTotalPrice }}</span>
                <span class="xianjin">现金余额</span>
                <span class="money">{{ cashBalance }}</span>
                <span class="xianjin">现金占用</span>
                <span class="money">{{ cashOccupy }}</span>
                <span class="xianjin">信贷余额</span>
                <span class="zhangqi">{{ creditBalance }}</span>
                <span class="xianjin">信贷占用</span>
                <span class="zhangqi">{{ creditOccupy }}</span>
                <span class="jiazhi">净价值</span>
                <span class="make">￥5000</span>
            </div>
        </div>
        <div class="h-pagination2 h-pageCenter">
            <pagination :page="q" @query="queryXiangmu"/>
        </div>
        <div class="anniu">
            <el-row>
                <a href="/dingd/material/inland">
                    <el-button class="quxiao" style="margin-right:10px;">取消</el-button>
                </a>
                <el-button class="zancun" @click="createNewOrder(10)">暂存</el-button>
                <el-button class="queren" @click="createNewOrder(20)">确认提交</el-button>
            </el-row>
        </div>
        <areaSelect :dialogFormVisible=false></areaSelect>
    </div>
</template>
<style scoped>
    .queren {
        background-color: #006aca;
        color: white;
    }
    .anniu {
        margin-left: 6rem;
        margin-top: 30px;
    }
    .zancun {
        background-color: #24b5b8;
        color: white;
    }

    .quxiao, .zancun {
        width: 100px;
    }

    .bizhong, 
    .dingdan,
    .xianjin, 
    .jiazhi{
        width: 8%;
        text-align: center;
    }
    .renminbi,
    .money,
    .yuan,
    .zhangqi,
    .make {
        background-color: white;
        font-size: 10px;
    }

    .renminbi, .yuan, .money, .zhangqi, .make{
        width: 10%;
        text-align: center;
       

    }
    .bizhong,
    .renminbi,
    .dingdan,
    .xianjin,
    .yuan,
    .zhangqi,
    .zhanyong,
    .jiazhi,
    .make {
        font-size: 15px;
        color: black;
        padding:10px 0;
    }
    .jieguo {
        border-bottom: 1px solid rgb(238, 236, 236);
        display: flex;
        margin-top: 12px;
        width: 100%;
        padding-right: 20px;
       
    }
    span {
        color: white;
        position: relative;
        top: -12px;
        left: 20px;
        font-size: 14px;
    }
    img {
        width: 25px;
        padding: 5px 0;
        margin-left: 8rem;
    }
    .h-piece {
        margin: 20px;
    }

    .h1 {
        margin-left: 27px;
    }

    .DshuR {
        width: 100%;
        height: 100%;
        border: none;
    }

    .bbbb {
        margin: 20px 20px 0 20px;
    }

    .message {
        padding: 20px 0;
        margin-bottom: 0;
        background-color: white;
    }

    .n-xiao .h-formbLine .h-elformWrap-2,
    .n-two .h-formbLine .h-elformWrap-2 {
        width: 33.333%;
    }

    .el-cascader {
        line-height: normal;
    }
</style>
<style>
    .n-xiao .h-formbLine .el-form-item__label,
    .n-two .h-formbLine .el-form-item__label {
        width: 43%;
    }

    .n-xiao .h-formbLine .el-form-item__content,
    .n-two .h-formbLine .el-form-item__content {
        width: 57%;
    }


    /* .el-table__header .el-table-column--selection .cell .el-checkbox::after {
        content: "全选";
        color: white;
        background-color: rgb(93, 172, 236);
        font-size: 10px;
    } */
</style>

<script>
    import ss from '../../../api/SystemService'
    import big from 'big.js'

    export default {

        //页面加载前事件
        created() {
            this.projectManagePage();
            this.queryMoney();
            this.showMeYourMoney();
        },

        methods: {
            //定制需求数据字典替换,定制为否时禁用选项
            queryCust(n) {
                n.forEach(function (val, index) {
                    val.cflag = val.spare3 == 0 ? true : false;

                    val.spare3 = val.spare3 === 0 ? '不可定制' : val.spare3;
                })
                this.tableData2 = n;
            },

            //分销渠道改变后方法
            handleChange(value) {
                if (value.length > 1) {
                    console.log(value.length + 'ffff' + value[0] + value[1])
                    this.tableData.orderData.disChannelCode = value[0];
                    this.tableData.orderData.zCode = value[1];
                } else {
                    this.tableData.orderData.disChannelCode = value[0];
                }
            },

            //下单金额扣除
            showMeYourMoney() {
                this.cashOccupy = this.creditOccupy = 0;
                if (this.allTotalPrice <= this.cashBalance) {
                    //现金足够扣现金
                    this.cashOccupy = this.allTotalPrice;
                    //现金不足扣信贷
                } else if (this.allTotalPrice > this.cashBalance) {
                    //现金全部扣完
                    this.cashOccupy = this.cashBalance;
                    //剩余部分扣信贷
                    this.creditOccupy = this.allTotalPrice - this.cashBalance;
                }
            },
            //查询余额
            queryMoney() {
                ss.OrderService.queryMoney().then(rd => {
                    this.cashBalance = rd.obj.cashBalance;
                    this.creditBalance = rd.obj.creditBalance;
                });
            },

            //勾选事件
            handleSelectionChange(val) {
                this.multipleSelection = val;
                this.getAllTotalPrice(val);
            },
            //计算每行成交价
            getFinalPrice(x) {
                x.forEach((item, index) => {
                    var c = 0;
                    if (item.specialPrice > 0) {
                        c = new big(item.specialPrice).plus(item.extraPrice);
                    } else {
                        c = new big(item.finalPrice).plus(item.extraPrice);
                    }
                    item.finalPrice = c.toString();
                })
                this.tableData2 = x;
            },
            //计算每行总价
            getETotalPrice(x) {
                x.forEach((item, index) => {
                    item.totalPrice = new big(item.proNumber).times(item.finalPrice).toString();
                })
                this.tableData2 = x;
                this.getAllTotalPrice(this.tableData2);
            },
            //数量改变-总价改变
            getTotalPrice(n) {
                var c = 0;
                if (n.specialPrice != '') {
                    if (n.specialPrice > 0) {
                        c = new big(n.specialPrice).plus(n.extraPrice);
                    } else {
                        c = new big(n.finalPrice).plus(n.extraPrice);
                    }
                } else {
                    c = n.finalPrice;
                }
                n.proNumber = n.proNumber == '' ? 0 : n.proNumber;
                n.totalP = new big(n.proNumber).times(c);
                n.totalPrice = (n.totalP).toString();
                n.finalPrice = c.toString();
                this.getAllTotalPrice(n);
            },

            //总价总和改变
            getAllTotalPrice(n) {
                n.allTotalPrice = 0;
                this.multipleSelection.forEach(function (val, index) {
                    n.allTotalPrice = new big(n.allTotalPrice).plus(val.totalPrice);
                })
                this.allTotalPrice = n.allTotalPrice.toString();
                this.showMeYourMoney();
            },

            //获取该项目下所有产品行
            queryXiangmu() {
                ss.OrderService.getFilteredProductPage(this.q).then(rd => {
                    this.q.total = rd.total;
                    this.page = rd
                    this.tableData2 = rd.records;
                    this.getFinalPrice(this.tableData2);
                    this.getETotalPrice(this.tableData2);
                    //币种
                    var aaa = '';
                    this.tableData2.forEach(function (val, index) {
                        aaa = val.currencyCode;
                    })
                    this.currency = aaa;

                    this.queryCust(this.tableData2);
                })


                if (this.q.id == '') {
                    this.showHidden = true;
                    this.showHidden2 = false;
                } else {
                    this.showHidden = false;
                    this.showHidden2 = true;
                }

            },
            newZen() {
                var objectList = {
                    materialCode: '',
                    proModelCode: '',
                    proNumber: '',
                    proBenchmarkPrice: '',
                    specialPrice: '',
                    isStockUp: '',
                    spare3: '',
                    extraPrice: '',
                    finalPrice: '',
                    totalPrice: '',
                    spare1: '',
                    contactName: '',
                    toAddress: '',
                    receivedTime: ''
                }
                this.tableData2.push(objectList)
            },

            //自行添加一行产品信息
            getSingleOrder(x) {
                ss.OrderService.getSingleOrder(x).then(rd => {
                    x.proModelCode = rd.proModelCode;
                    x.proBenchmarkPrice = rd.proBenchmarkPrice;
                    x.finalPrice = rd.proBenchmarkPrice;
                    this.getTotalPrice(x);
                });
            },

            //获取当前用户所有项目详情
            projectManagePage() {
                ss.OrderService.projectManagePage().then(rd => {
                    this.allProjectByUser = rd;
                });
            },

            //创建新订单
            createNewOrder(p) {
                if( this.multipleSelection.length == 0){
                    this.$msg.msge('请勾选产品后再提交订单!');
                    return;
                }
                this.tableData.orderStatus = p;
                this.tableData.orderProjectCode = this.q.id;
                this.tableData.orderData.currencyCode = this.currency;
                this.tableData.orderData.orderCategory = this.formInline.orderCategory;
                this.tableData.orderData.saleGroupCode = this.formInline.saleGroupCode;


                var tableData111 = [];
                this.multipleSelection.forEach(function (val, index) {
                    val.spare3 = val.spare3 == '否' ? 0 : 1;
                    tableData111.push(val);
                })
                this.tableData.orderProductList = tableData111;
                console.log('哈哈哈哈哈1' + this.tableData.orderData.zCode);
                ss.OrderService.createNewOrder(this.tableData).then(rd => {
                    this.$msg.msgs(rd.msg);
                    this.jump();
                });
            },
            //跳转页面
            jump() {
                this.$router.push({path: "/dingd/material/inland"})
            },
            mounted() {
                //  this.queryXiangmu();
            },
        },

        data() {
            return {
                showHidden: true,
                showHidden2: false,
                objectName: '',
                //分销渠道
                options: [{
                    value: '00',
                    label: '通用分销渠道'
                }, {
                    value: 'X1',
                    label: '香港外销渠道'
                }, {
                    value: 'Z1',
                    label: '上海直销渠道',
                    children: [{
                        value: 'ZSH1',
                        label: '采购本部',
                    }, {
                        value: 'ZSH2',
                        label: '第三方采购',
                    }, {
                        value: 'ZSH3',
                        label: '第三方销售',
                    }],
                }],
                selectedOptions: [],

                //sap订单参数
                orderCategory: '',


                // 限制收货时间不让选择今天以前的
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
                    }
                },

                cflag: false,
                //现金及信贷
                cashBalance: 0,
                cashOccupy: 0,
                creditBalance: 0,
                creditOccupy: 0,
                allTotalPrice: 0,
                currency: '',
                expectTime: '',

                //查询属性
                q: {
                    id: '',
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                labelPosition: 'left',
                formInline: {
                    orderCategory: '',
                    saleGroupCode: '',
                    disChannelCode: '',
                    zCode: '',
                },
                multipleSelection: [],
                //创建订单数据
                tableData: {
                    orderStatus: 1,
                    orderProjectCode: '',
                    orderData: {
                        currencyCode: '',
                        orderCategory: '内销订单',
                        saleGroupCode: '',
                        disChannelCode: '',
                        zCode: '',
                    },
                    orderProductList: [],
                },
                tableData2: [],
                //根据用户id查询出的所有项目
                allProjectByUser: [],
                clickActive: 1,

                // rules: {
                //     name: [
                //         {required: true, message: '', trigger: 'blur'},
                //     ],
                // }
            };
        },
    }

</script>


